function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { Manager, Reference, Popper } from "react-popper";
import { ReactComponent as ArrowIconComponent } from "@svgr/webpack?-svgo,+titleProp,+ref!./toolbox.svg";
import { Icon, GridColumn } from "../";
const Arrow = styled.div`
  display: block;
  height: 27px;
  position: absolute;
  overflow: hidden;
  width: 30px;
`;
const ArrowIcon = styled(ArrowIconComponent)`
  &[data-singleuse=true] {
      use:last-child {
      fill: ${props => props.theme.colors.toolbarBackgroundSecondary};
    }
`;
const RemoveContainer = styled(GridColumn)`
  display: flex;
  position: absolute;
  top: 0;
  height: 100%;
  right: 20px;
  cursor: pointer;
`;
const StyledToolbox = styled.div`
  background-color: ${props => props.singleUse ? props.theme.colors.toolbarBackgroundSecondary : props.theme.colors.toolbarBackground};
  border-radius: ${props => props.simple ? "8px" : props.singleUse ? "36px" : 0};
  box-shadow: ${props => props.simple ? "0 1px 4px 0 rgba(0,0,0,0.48)" : "0 8px 8px 0 rgba(0, 0, 0, 0.5), 0 0 8px 0 rgba(0, 0, 0, 0.48)"};
  box-sizing: border-box;
  display: block;
  max-width: 424px;
  padding: 24px;
  position: relative;
  width: 100%;
  z-index: 100;

  ${props => props.singleUse && `padding: 16px 24px;`}

  &[data-placement*="top"] {
    ${Arrow} {
      bottom: -27px;
    }
  }

  &[data-placement*="bottom"] {
    ${Arrow} {
      top: -27px;
      transform: rotate3d(0, 0, 1, 180deg);
    }
  }

  &[data-placement*="left"] {
    ${Arrow} {
      right: -27px;
      transform: rotate3d(0, 0, 1, -90deg);
    }
  }
  &[data-placement*="right"] {
    ${Arrow} {
      left: -28px;
      transform: rotate3d(0, 0, 1, 90deg);
    }
  }
`;
const SvgContainer = styled.div`
  margin-top: -8px;
`;
const modifiers = {
  offset: {
    offset: "0, 20"
  }
};
export const Toolbox = ({
  placement,
  children,
  trigger,
  open,
  simple = false,
  singleUse = false,
  ...props
}) => {
  const [id] = useState(Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
  const [isOpen, setOpen] = useState(singleUse);
  const toolboxRef = useRef();
  const portal = useRef();
  let internalOpen;

  if (open === undefined) {
    internalOpen = isOpen;
  } else {
    internalOpen = open;
  }

  const handleClick = () => {
    setOpen(!isOpen);
  };

  const handleClickOut = e => {
    if (toolboxRef.current && !toolboxRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  const handleRef = (ref, cb) => {
    toolboxRef.current = ref;
    cb(ref);
  };

  useEffect(() => {
    if (isOpen && !singleUse) {
      document.addEventListener("click", handleClickOut);
      return () => {
        document.removeEventListener("click", handleClickOut);
      };
    }
  }, [isOpen]);
  useEffect(() => {
    const target = document.createElement("div");
    target.id = `portal${id}`;
    document.body.appendChild(target);
    portal.current = document.getElementById(`portal${id}`);
    return () => {
      document.getElementById(`portal${id}`).remove();
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return React.createElement(Manager, null, React.createElement(Reference, null, props => trigger({
    onClick: singleUse ? undefined : handleClick,
    ...props
  })), React.createElement(Popper, _extends({
    modifiers: !!simple ? {
      offset: {
        offset: "0, 4"
      }
    } : !!singleUse ? {
      offset: {
        offset: "140, 20"
      }
    } : modifiers,
    placement: placement ? placement : "top"
  }, props), ({
    ref,
    style,
    placement,
    arrowProps
  }) => children && internalOpen && portal.current ? ReactDOM.createPortal(React.createElement(StyledToolbox, {
    ref: res => handleRef(res, ref),
    style: style,
    "data-placement": placement,
    simple: simple,
    singleUse: singleUse
  }, typeof children === "function" ? children({
    close: handleClose
  }) : children, !simple && React.createElement(Arrow, {
    ref: arrowProps.ref,
    style: arrowProps.style
  }, React.createElement(SvgContainer, null, React.createElement(ArrowIcon, _extends({
    "data-singleuse": singleUse
  }, props)))), !!singleUse && React.createElement(RemoveContainer, {
    onClick: handleClick,
    yCenter: true
  }, React.createElement(Icon, {
    platform: true,
    name: "Close",
    style: {
      width: "16px",
      height: "16px"
    }
  }))), portal.current) : null));
};